import React from 'react'

const Dashboard = ({setIsSidebar}) => {
    setIsSidebar(true);
  return (
    <div>
      HEllO
    </div>
  )
}

export default Dashboard
